export default __webpack_public_path__ + "static/media/redo.3b9fd250.svg";